export function isObject(val) {
  return val && val.constructor === Object;
}
